import {Pipe, PipeTransform} from '@angular/core';
import {DATE_FORMATS, EXCEPTION_DATES, getDateFormatI18} from "@shared/constants";
import {BusinessI18nService, LOCALE_CODE} from "@core/libs";
import {map, Observable} from "rxjs";
import {capitalizeFirstLetter} from "@shared/utils";
import moment from "moment";


type typeFormat = keyof typeof DATE_FORMATS['COMMON'] | string;


@Pipe({
  name: 'dateI18n',
  standalone: false
})
export class DateI18nPipe implements PipeTransform {
  constructor(
    private businessI18nService: BusinessI18nService,
  ) {
  }

  transform(val: any, type: typeFormat): Observable<any> {
    return this.businessI18nService.language$.pipe(
      map(language => {
        if (!val || EXCEPTION_DATES.includes(val) || !type) {
          return '';
        }
        if (!this.isFormatI18n(type)) {
          return '';
        }

        return this.transformFormatI18n(val, type, language);
      })
    )

  }

  /**
   * ---------------------------------------------------------------------------------------------------------
   * Handle I18n ---------------------------------------------------------------------------------------------
   * ---------------------------------------------------------------------------------------------------------
   * */

  private transformFormatI18n(date: string, type: keyof typeof DATE_FORMATS['COMMON'], language: LOCALE_CODE) {
    const isLocaleVI = language === 'vi-VN';
    let format = getDateFormatI18(type, isLocaleVI);
    if (!format) {
      return '';
    }

    moment.locale(language);
    const momentDate = moment(date);

    /**
     * Định dạng FULL_DATE đang chưa hiển thị đúng vơi locale == vi 100%
     * nên cần xử lý riêng lại
     * - Để nguyên sẽ ra "thứ năm, tháng 12 26, 2024"
     * - Cần trả được dạng "Thứ 5, ngày 26 tháng 12 năm 2024"
     * */
    if (language === 'vi-VN' && type == 'FULL_DATE') {
      const weekday = momentDate.format('dddd'); // Thứ trong tuần (ví dụ: thứ năm)
      const day = momentDate.format('DD'); // Ngày (2 chữ số)
      const month = momentDate.format('MM'); // Tháng (2 chữ số)
      const year = momentDate.format('YYYY'); // Năm đầy đủ
      return `${capitalizeFirstLetter(weekday)}, ngày ${day} tháng ${month} năm ${year}`;
    }


    // Kiểm tra nếu ngày thuộc năm hiện tại và type là 'SHORT_DATE'
    if (momentDate.year() === moment().year() && type === 'SHORT_DATE') {
      format = getDateFormatI18('TINY_DATE', isLocaleVI);
    }

    return momentDate.format(format as string);
  }

  private isFormatI18n(type: typeFormat): type is keyof typeof DATE_FORMATS['COMMON'] {
    return type in DATE_FORMATS['COMMON'];
  }
}

